import { render } from "./StudentList.vue?vue&type=template&id=72d0ded9"
import script from "./StudentList.vue?vue&type=script&lang=js"
export * from "./StudentList.vue?vue&type=script&lang=js"

import exportComponent from "/home/eigyo65user/mystep/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__